module.exports = __webpack_public_path__ + "static/img/dataVizAppImg.2adc0b3.png";